var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecordanIncident(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 43,
    viewBox: "0 0 39 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.231 40.25L18.481 29L16.231 20L9.48096 11M9.48096 11H18.481L25.231 4.25M9.48096 11L2.73096 20L4.98096 29M21.856 20H27.481L36.481 24.5M2.73096 4.25C2.73096 4.84674 2.96801 5.41903 3.38997 5.84099C3.81192 6.26295 4.38422 6.5 4.98096 6.5C5.57769 6.5 6.14999 6.26295 6.57195 5.84099C6.9939 5.41903 7.23096 4.84674 7.23096 4.25C7.23096 3.65326 6.9939 3.08097 6.57195 2.65901C6.14999 2.23705 5.57769 2 4.98096 2C4.38422 2 3.81192 2.23705 3.38997 2.65901C2.96801 3.08097 2.73096 3.65326 2.73096 4.25Z",
    stroke: "#278DEC",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordanIncident);
export default __webpack_public_path__ + "static/media/RecordanIncident.d70d472e051dddad7b97c984a4844a60.svg";
export { ForwardRef as ReactComponent };